import { STATIC_URL } from '../../Env'
import logo from '../../assets/logo.svg'
import moment from 'moment';
import { Link } from 'react-router-dom';

const AuthorRow = ({ author, author_pic, post }) => {
    return (
        <div className="author">
            <div className="avatar">
                {author_pic ? (
                    <img src={`${STATIC_URL}${author_pic}`} />
                ) : (
                    <div className="gs-img"><img src={logo} /></div>
                )}
            </div>
            <div className="infos">
                <p className="name">{author || "Giftswap"}</p>
                <p className="date">{moment(post.date).format('MMMM dd, YYYY')}</p>
            </div>
            <div className="more">
                <Link to={"/blog/posts/" + post.id}><p>Read more</p></Link>
            </div>
        </div>
    )
}

export { AuthorRow }